module.exports = __webpack_public_path__ + "img/logo.0e03ee80.png";